import useConfig from 'modules/config/state/use-config'
import AnonymousOptionsRow from './anonymous-options-row'
import { OptInFormField, OptInSmsFormField } from './opt-in-form-fields'

export const FloatingOptions = () => {
  const config = useConfig()

  return (
    <>
      <AnonymousOptionsRow />
      {config.optIn.isEnabled && <OptInFormField />}
      {config.optInSms.isEnabled && <OptInSmsFormField />}
    </>
  )
}
